import React, { useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import useLenis from "@/hooks/useLenis";
import useCountry from "@/hooks/useCountry";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import Manifesto from "@/components/site/Manifesto";
import BooksShowcase from "@/components/site/BooksShowcase";
import MeetMaya from "@/components/site/MeetMaya";
import AuthorSection from "@/components/site/AuthorSection";
import Testimonials from "@/components/site/Testimonials";
import Newsletter from "@/components/site/Newsletter";
import Footer from "@/components/site/Footer";
import SocialsPage from "@/pages/SocialsPage";
import AboutPage from "@/pages/AboutPage";
import GiftGuidePage from "@/pages/GiftGuidePage";

function Home() {
  useLenis();
  const newsletterRef = useRef(null);
  const { country, status, setCountry } = useCountry();

  const scrollToNewsletter = () => {
    const el = document.getElementById("newsletter");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="relative" data-testid="home-root">
      <div className="grain-overlay" aria-hidden="true" />
      <Header
        onSubscribeClick={scrollToNewsletter}
        country={country}
        onCountryChange={setCountry}
      />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <BooksShowcase country={country} countryStatus={status} />
        <MeetMaya />
        <Testimonials />
        <AuthorSection />
        <Newsletter ref={newsletterRef} />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "var(--ink)",
              color: "var(--paper)",
              border: "1px solid rgba(249,248,243,0.2)",
              borderRadius: 0,
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/socials" element={<SocialsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/gift-guide" element={<GiftGuidePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
